var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-end"},[_vm._t("footer_buttons",function(){return [_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.create(_vm.model_name)}}},[_vm._v(" Nuevo "+_vm._s(_vm.singular(_vm.model_name))+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }